import React, { Component } from "react";
import Explore from "../components/Page/Home/Explore";
import UseCase from "../components/Page/Home/UseCase";
import Features from "../components/Page/Home/Features";
import Content from "../components/Content";
import Slider from "../components/HomeSlider"


const items = [
  {
    alt: "Restaurant",
    image: '//cdn.lumio.id/w944/tojpeg/s3:ap-southeast-1:lumio:web/restaurant.jpg',
  },
  {
    alt: "Weather App",
    image: '//cdn.lumio.id/w944/tojpeg/s3:ap-southeast-1:lumio:web/weatherApp.jpg',
  },
  {
    alt: "Instagram",
    image: '//cdn.lumio.id/w944/tojpeg/s3:ap-southeast-1:lumio:web/social_insta.jpg',
  },
  {
    alt: "Twitter",
    image: '//cdn.lumio.id/w944/tojpeg/s3:ap-southeast-1:lumio:web/social_twitter.jpg',
  },
  {
    alt: "Twitter",
    image: '//cdn.lumio.id/w944/tojpeg/s3:ap-southeast-1:lumio:web/VMS.png',
  }
]

const settings = {
  items: items,
  arrows: false,
  infinite: true,
  fade: true,
  autoplay: true,
  autoplaySpeed: 5000,
  pauseOnHover: false,
  speed: 500,
  slidesToShow: 1,
  swipe: false
};

export default class Home extends Component {
  render() {
    return (
      <section>
        <Content fitToBox={true} innerClassName="bg-white fit-side fit-top" className="push-top">
          <div className="frame">
            <Slider {...settings}/>
          </div>
        </Content>
        <Content innerClassName="bg-white">
          <Explore/>
        </Content>
        <Content className="bg-clear-blue">
          <div className="row">
            <div className="col-md-6">
              <h2 className="white">
                Leverage Your Digital Signage To The Next Level
                <hr/>
              </h2>
            </div>
            <div className="col-md-6">
              <p>Signage is now used across many walks of life,
                empowering information sharing and used in many new applications as never before.
                Lumio enables you to display and convey your message in a new way.</p>

            </div>
          </div>
        </Content>
        <UseCase className="bg-black bg-use-case"/>
        <Features/>
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/Home.js